import Logger from '../logger';

const logger = new Logger('PeerConnectionUtils');

export const setupPeerConnectionDebug = (pc) => {
	if (!pc) return;

	pc.addEventListener('icecandidateerror', (e) => console.error('ICE candidate error', e));
	pc.addEventListener('iceconnectionstatechange', () => logger.debug('ICE connection state:', pc.iceConnectionState));
	pc.addEventListener('connectionstatechange', () => logger.debug('Connection state:', pc.connectionState));

	let bytesReceived = 0;
	let noPacketWarningCount = 0;

	const statsInterval = setInterval(async () => {
		try {
			const stats = await pc.getStats();
			stats.forEach(report => {
				if (report.type === 'inbound-rtp' && report.kind === 'audio') {
					const newBytesReceived = report.bytesReceived || 0;

					if (bytesReceived > 0 && newBytesReceived === bytesReceived) {
						noPacketWarningCount++;
						if (noPacketWarningCount >= 5) {
							logger.error('No RTP data for 5 consecutive checks - audio connection may be broken');
							const globalAudioElement = document.getElementById('jssip-audio-element');
							if (globalAudioElement) {
								globalAudioElement.play().catch(() => { });
							}
						}
					} else {
						noPacketWarningCount = 0;
					}

					bytesReceived = newBytesReceived;
				}
			});
		} catch (e) {
			logger.error('Error getting WebRTC stats:', e);
		}
	}, 1000);

	setTimeout(() => clearInterval(statsInterval), 20000);
};


